module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/ko_3-d472a1e91aa666a34be9e91ff27cda74.jpg";